import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const postProductCategory = categoryInfo => {
  return httpClient
    .post('/admin/productCategory', categoryInfo)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAllProductCategory = () => {
  return httpClient
    .get('/admin/productCategory')
    .then(response => response)
    .catch(error => error.response);
};

export const updateProductCategory = (id, categoryInfo) => {
  return httpClient
    .patch(`/admin/productCategory/${id}`, categoryInfo)
    .then(response => response)
    .catch(error => error.response);
};

export const deleteProductCategory = id => {
  return httpClient
    .delete(`/admin/productCategory/${id}`)
    .then(response => response)
    .catch(error => error.response);
};
